const BASE_URL = "https://api.farmakom.it";

export const API_URL_FRONTEND = BASE_URL + "/v1/frontend";
